import React from 'react';
import { Box } from '@chakra-ui/react';
import SectionHeading from './section-heading';
import WebProjectCard from './projects/web-project-card';
import { WEB_PROJECTS } from '../data/web-projects';

/**
 * Personal web apps, kept separate from My Works: those are jobs and study
 * projects, these are things I built and put online on my own.
 */
export default function MyProjects() {
  return (
    <Box mt={'90px'}>
      <SectionHeading index="05">My Projects</SectionHeading>
      <Box className="project-list">
        {WEB_PROJECTS.map(project => (
          <WebProjectCard key={project.id} project={project} />
        ))}
      </Box>
    </Box>
  );
}
